export interface IAddFreeGISBundleCreditsRequest {
    BundleID: number;
    Credits: number;
}

export class AddFreeGISBundleCreditsRequest {
    BundleID: number;
    Credits: number;
}
